import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/models')({
  head: () => ({
    meta: [{ title: 'Models | Tekst' }],
  }),
  component: () => <Outlet />,
});
